module.exports = __webpack_public_path__ + "static/media/ProjectStep3.ba394259.png";